import { Injectable } from '@angular/core';

import { Tax } from '../business-entities/tax.model';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';

@Injectable({ providedIn: 'root' })
export class TaxDetailsDataService {

    constructor(
        private dataProvider: DataService
    ) {}

    getTaxPercentages(dealerId: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetTaxPercentages, dealerId).toPromise();
    }

    updatetaxPercentages(taxPercentages: Tax[]): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdatetaxPercentages, taxPercentages).toPromise()
    }
}